import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    name,
    description,
    startDate,
    endDate,
    priority,
    Status,
    projectId,
    ResponsibilityText,
    SolutionDescription,
  },
} = checkout;

const validations = [
  Yup.object().shape({
    // [name.name]: Yup.string().required(name.errorMsg),
    [description.name]: Yup.string().required(description.errorMsg),
    [startDate.name]: Yup.date().required(startDate.errorMsg),
    [endDate.name]: Yup.date().required(endDate.errorMsg),
    [priority.name]: Yup.number().required(priority.errorMsg).min(0),
    [Status.name]: Yup.number().required(Status.errorMsg).min(0),
    [projectId.name]: Yup.string().required(projectId.errorMsg),
    [ResponsibilityText.name]: Yup.string().required(ResponsibilityText.errorMsg),
    [SolutionDescription.name]: Yup.string().required(SolutionDescription.errorMsg),
  }),
];

export default validations;
